module.exports = __webpack_public_path__ + "img/08.2bd2cc2e.png";